import React, { useEffect, useState, useRef } from "react";
import SideBar from "../elements/sidebar";
import HomemainHeader from "../components/homemainheader";
import BreadCrumb from "../elements/breadcrumb";
import "../styles/casesimulation.css";
import Aichat from "../elements/aichat";
import { MdOutlineEdit } from "react-icons/md";

const questionimage =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/lounge/question.svg";

export default function CaseSim({ header, topic }) {
  const toggleSidebar = () => {
    setIsSidebarCollapsed((prevState) => !prevState);
  };
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(
    window.innerWidth < 1000 ? true : false
  );
  const searchTags = [
    "High Phytanic Acid",
    "Retinitis Pigmentosa",
    "Ataxia",
    "Tangling Sensation",
  ];
  const [activeSection, setActiveSection] = useState(0);

  useEffect(() => {
    console.log("Topics: ", topic);
  }, [topic]);
  return (
    <div className="homemain casesimulationbackground">
      <SideBar
        selected="CaseSimulation"
        isCollapsed={isSidebarCollapsed}
        onToggle={toggleSidebar}
      />

      <div
        className="homeright"
        style={{
          marginLeft: isSidebarCollapsed ? "110px" : "370px",
        }}
      >
        <Aichat sidebarCollapsed={isSidebarCollapsed} />
        <HomemainHeader
          onToggle={toggleSidebar}
          isSidebarCollapsed={isSidebarCollapsed}
        />
        <BreadCrumb element="Search Results" />
        <h1 className="casesimulationheadertext">{header}</h1>
        <div className="casesimulationsearch">
          <div className="casesimulationsearchtop">
            <div className="casesimulationsearchtags">
              {Array.isArray(topic) ? (
                topic.map((tag, index) => (
                  <div key={index} className="casesimulationtags">
                    {tag}
                  </div>
                ))
              ) : (
                <div className="casesimulationquestionsummary">
                  <p>{topic}</p>
                  <MdOutlineEdit />
                </div>
              )}
            </div>
            {Array.isArray(topic) && (
              <img src={questionimage} alt="Question Image" />
            )}
          </div>
        </div>
        <div className="casesimulationbody">
          <div className="casesimulationsections">
            <div
              className={`${
                activeSection === 0 ? "casesimulationsectionactive" : ""
              } casesimulationsection `}
              onClick={() => setActiveSection(0)}
            >
              High Phytanic acid{" "}
            </div>
            <div
              className={`${
                activeSection === 1 ? "casesimulationsectionactive" : ""
              } casesimulationsection `}
              onClick={() => setActiveSection(1)}
            >
              Section 2
            </div>
            <div
              className={`${
                activeSection === 2 ? "casesimulationsectionactive" : ""
              } casesimulationsection `}
              onClick={() => setActiveSection(2)}
            >
              Section 3
            </div>
          </div>
          <div className="casesimulationmainbodycontent">
            <h4>Proteasome Inhibitors in Multiple Myeloma:</h4>
            <h5>Mechanism of Action:</h5>
            <p>
              <ul>
                <li>
                  <strong>Proteasome Inhibition:</strong> Proteasome inhibitors
                  block the proteasome, a complex that degrades unneeded or
                  damaged proteins within the cell.
                </li>
                <li>
                  <strong>Accumulation of Misfolded Proteins:</strong>{" "}
                  Inhibiting the proteasome leads to the accumulation of
                  ubiquitinated proteins, causing stress on the endoplasmic
                  reticulum (ER) and inducing apoptosis.
                </li>
                <li>
                  <strong>NF-κB Pathway Inhibition:</strong> Reduced degradation
                  of IκB, an inhibitor of NF-κB, which leads to decreased NF-κB
                  activity. NF-κB is involved in cell survival and
                  proliferation, so its inhibition promotes cell death.
                </li>
                <li>
                  <strong>Induction of Apoptosis:</strong> Through these
                  mechanisms, proteasome inhibitors selectively induce apoptosis
                  in myeloma cells, which are more dependent on proteasome
                  function due to their high protein turnover rate.
                </li>
              </ul>
            </p>
            <h5>Indications:</h5>
            <p>
              <ul>
                <li>
                  Primarily used for the treatment of multiple myeloma, both in
                  newly diagnosed and relapsed/refractory cases.
                </li>
                <li>
                  Also used in mantle cell lymphoma and other lymphoid
                  malignancies.
                </li>
              </ul>
            </p>
            <h5>Typical Proteasome Inhibitors Used:</h5>
            <p>
              <ul>
                <li>
                  <strong>Bortezomib (Velcade):</strong> Administered either
                  intravenously (IV) or subcutaneously.
                </li>
                <li>
                  <strong>Carfilzomib (Kyprolis):</strong> Administered
                  intravenously.
                </li>
                <li>
                  <strong>Ixazomib (Ninlaro):</strong> Administered orally.
                </li>
              </ul>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
